import { httpsCallable, HttpsCallableResult } from 'firebase/functions';
import { useCallback, useState } from 'react';
import FirebaseFunctions from '../services/FirebaseFunctions';

const methodName = 'v1_apitoken_create' as const;

export type CreateApiTokenResult = HttpsCallableResult<{ id: string }>
export type CreateApiTokenData = {
  id?: string,
  scope?: string[]
};

export type CreateApiToken = Readonly<[
  run: (data: CreateApiTokenData) => Promise<CreateApiTokenResult>,
  progress: boolean,
  err?: Error
]>;

export const useCreateApiToken = (): CreateApiToken => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);
  const run = useCallback(
    async (data: CreateApiTokenData): Promise<CreateApiTokenResult> => {
      setLoading(true);
      setError(undefined);
      try {
        const callable = httpsCallable<
          { action: typeof methodName; data: CreateApiTokenData },
          { id: string }
        >(FirebaseFunctions, 'app');
        return await callable({ action: methodName, data });
      } catch (err) {
        const e = err instanceof Error ? err : new Error(String(err));
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    []
  );
  return [run, loading, error];
};
